import React from 'react';
import { TableHeading, TableRow } from 'models/interfaces/Table';
import { printDate } from 'util/dateUtils';
import { P3Configuration } from 'models/interfaces/P3Configurations';
import {
  EditIcon,
  DuplicateIcon,
  DeleteIcon,
  AssignIcon,
  GrayEditIcon,
  GrayDeleteIcon
} from '../Icons/EditIcons';
import { Link } from 'react-router-dom';
import { configurationValidPoints } from '@tpco/tpco-saturn-logic';
import { IP3Campaign, IP3Configuration } from '@tpco/tpco-saturn-types';

const configurationTemplateHeadings: TableHeading[] = [
  {
    key: 'name',
    value: 'Name'
  },
  {
    key: 'total_points',
    value: 'Points',
    style: 'align-right'
  },
  {
    key: 'coverage_areas',
    value: 'Coverage Areas',
    style: 'align-right'
  },
  {
    key: 'created_date',
    value: 'Date Created',
    style: 'align-right'
  },
  {
    key: 'action',
    value: 'Actions',
    style: 'align-center'
  }
];

const associatedConfigurationHeadings: TableHeading[] = [
  {
    key: 'name',
    value: 'Name'
  },
  {
    key: 'companyName',
    value: 'Company Name'
  },
  {
    key: 'total_points',
    value: 'Points',
    style: 'align-right'
  },
  {
    key: 'coverage_areas',
    value: 'Coverage Areas',
    style: 'align-right'
  },
  {
    key: 'created_date',
    value: 'Date Created',
    style: 'align-right'
  },
  {
    key: 'action',
    value: 'Actions',
    style: 'align-center'
  }
];

const createTemplateRow = (
  p3Configuration: P3Configuration,
  onEditTemplate,
  onDuplicateTemplate,
  onDeleteTemplate,
  onAssignTemplate,
  showAssignTemplate,
  templateIsEditable
) => {
  const templateRow: TableRow = { ...p3Configuration };

  // set edit, duplicate, and delete funcs
  templateRow.action = (
    <div className="creative-list__action-container">
      {templateIsEditable ? (
        <button
          className="btn creative-list__action btn-fix"
          style={{ padding: '0', margin: '0' }}
          onClick={() => onEditTemplate(p3Configuration.p3_configuration_id)}
        >
          <EditIcon />
        </button>
      ) : (
        <button className="btn creative-list__action btn-fix" style={{ padding: '0', margin: '0' }}>
          <GrayEditIcon />
        </button>
      )}
      {showAssignTemplate ? (
        <button
          className="btn creative-list__action btn-fix"
          style={{ padding: '0', margin: '0' }}
          onClick={() => onAssignTemplate(p3Configuration.p3_configuration_id)}
        >
          <AssignIcon />
        </button>
      ) : null}
      <button
        className="btn creative-list__action btn-fix"
        style={{ padding: '0', margin: '0' }}
        onClick={async () => {
          await onDuplicateTemplate(p3Configuration.p3_configuration_id);
        }}
      >
        <DuplicateIcon />
      </button>
      {templateIsEditable ? (
        <button
          className="btn creative-list__action btn-fix"
          style={{ padding: '0', margin: '0' }}
          onClick={async () => await onDeleteTemplate(p3Configuration.p3_configuration_id)}
        >
          <DeleteIcon />
        </button>
      ) : (
        <button className="btn creative-list__action btn-fix" style={{ padding: '0', margin: '0' }}>
          <GrayDeleteIcon />
        </button>
      )}
    </div>
  );

  // override existing p3 data
  templateRow.created_date = p3Configuration.created_date
    ? printDate(p3Configuration.created_date)
    : '';
  const iP3Configuration: IP3Configuration = {
    rank_points: p3Configuration.rank_points,
    coverage_areas: p3Configuration.coverage_areas
  } as IP3Configuration;

  templateRow.total_points = configurationValidPoints(iP3Configuration);
  templateRow.companyName = (
    <Link to={`/advertisers/${templateRow.tgrams_id}/products/2`}>
      <span className="thomas-advertisers__advertiser-name">{templateRow.companyName}</span>
    </Link>
  );

  return templateRow;
};

const createTemplateRows = (
  p3Configurations: P3Configuration[] = [],
  onEditTemplate,
  onDuplicateTemplate,
  onDeleteTemplate,
  onAssignTemplate,
  showAssignTemplate,
  templateIsEditable
) => {
  return p3Configurations.map((p3: P3Configuration) =>
    createTemplateRow(
      p3,
      onEditTemplate,
      onDuplicateTemplate,
      onDeleteTemplate,
      onAssignTemplate,
      showAssignTemplate,
      templateIsEditable
    )
  );
};

export {
  configurationTemplateHeadings,
  associatedConfigurationHeadings,
  createTemplateRows,
  createTemplateRow
};
